import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingLeft: 25,
    paddingRight: 25,
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: 1170,
    marginHorizontal: 'auto'
  },
  card: {
    backgroundColor: '#fff',
    marginTop: 20,
    borderRadius: 10,
    height: 350
  },
  view: {
    marginTop: 20,
  },
  frontCover: {
    width: '100%',
    height: 140,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
  },
  nameCategory: {
    position: 'absolute',
    marginTop: 110,
    textAlign: 'center',
    color: '#fff',
    fontWeight: 'bold',
    width: '100%',
  },
  contentDescription: {
    padding: 15,
    marginTop: 20
  },
  description: {
    textAlign: 'justify',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 16
  },
  contentBtn: {
    marginTop: 10,
    marginBottom: 10,
    paddingHorizontal: 25,
    width: '100%'
  },
  btn: {
    padding: 10,
    borderRadius: 20,
  },
  textBtn: {
    color: '#fff',
    textAlign: 'center',
    fontSize: 18,
    fontWeight: '500'
  },
  label: {
    fontSize: 14,
    marginBottom: 10,
    marginTop: 20
  },
  input: {
    width: "90%",
    borderBottomWidth: 0.5,
    lineHeight: 35
  },
});

export default styles;
